<div class="modal-header">
	<h4 class="modal-title">{{ dialogTitle }}</h4>
	<button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div *ngIf="project" class="modal-body">
	<div ngbAccordion>
		<div ngbAccordionItem [disabled]="true" [collapsed]="false">
			<h2 ngbAccordionHeader>
				<button ngbAccordionButton>Projektdaten</button>
			</h2>
			<div ngbAccordionCollapse>
				<div ngbAccordionBody>
					<ng-template>
						<div class="mb-2 d-flex align-items-center">
							<label for="projectName" class="small fw-bold me-2 mb-0">Name:</label>
							<input type="text" class="form-control form-control-sm flex-grow-1" id="projectName"
								[(ngModel)]="project.name" placeholder="Projektname"
								[class.is-invalid]="isNameTakenOrNoProject">
							@if (isNameTaken) {
								<div class="invalid-feedback d-block">Name bereits vergeben</div>
							}
						</div>
						<div class="mb-2">
							<label for="projectDescription" class="form-label small fw-bold mb-1">Beschreibung</label>
							<textarea class="form-control form-control-sm" id="projectDescription" rows="2"
								[(ngModel)]="project.description" placeholder="Projektbeschreibung"></textarea>
						</div>
						@if (!isUserManager && !canManageParticipants && !isEditMode) {
							<div class="mt-2">
								<small class="fw-bold">Eigentümer:</small>
								<small class="text-muted ms-1">{{ project.owner?.username }}</small>
							</div>
						}
					</ng-template>
				</div>
			</div>
		</div>
		@for (assignConfig of assignmentConfigs; track assignConfig.projectField) {
			<div ngbAccordionItem [collapsed]="false">
				<h2 ngbAccordionHeader>
					<button ngbAccordionButton>{{ assignConfig.label }}</button>
				</h2>
				<div ngbAccordionCollapse>
					<div ngbAccordionBody>
						<ng-template>
							<bp-project-structure-assignment
								[config]="assignConfig" [project]="project">
							</bp-project-structure-assignment>
						</ng-template>
					</div>
				</div>
			</div>
		}
		@for (section of newSections; track section.id) {
			<div ngbAccordionItem [collapsed]="section.collapsed ?? true">
				<h2 ngbAccordionHeader>
					<button ngbAccordionButton>{{ section.label }}</button>
				</h2>
				<div ngbAccordionCollapse>
					<div ngbAccordionBody>
						<ng-template>
							<ng-container *ngComponentOutlet="section.component; injector: sectionInjector" />
						</ng-template>
					</div>
				</div>
			</div>
		}
		@if (canManageParticipants) {
			<div ngbAccordionItem [collapsed]="false">
				<h2 ngbAccordionHeader>
					<button ngbAccordionButton>Teilnehmer</button>
				</h2>
				<div ngbAccordionCollapse>
					<div ngbAccordionBody>
						<ng-template>
							<!-- Owner -->
							<div class="mb-2">
								<small class="fw-bold">Eigentümer:</small>
								<small class="text-muted ms-1">{{ project.owner?.username }}</small>
							</div>

							@if (loadingUsers) {
								<div class="text-center py-3">
									<div class="spinner-border spinner-border-sm" role="status">
										<span class="visually-hidden">Laden...</span>
									</div>
									<span class="ms-2">Benutzer werden geladen...</span>
								</div>
							}
							@if (usersError) {
								<div class="alert alert-danger" role="alert">
									{{ usersError }}
								</div>
							}
							@if (!loadingUsers && !usersError) {
								<div class="row g-2">
									@for (role of rolesConfig.memberRoles; track role.field) {
										@if (isRoleVisible(role)) {
											<div class="col">
												<label class="form-label fw-bold small mb-1">{{ role.labelPlural }}</label>
												@if (getAvailableMembers(role).length === 0) {
													<div class="text-muted small">{{ role.emptyText }}</div>
												} @else {
													<div class="list-group list-group-flush" style="max-height: 150px; overflow-y: auto;">
														@for (user of getAvailableMembers(role); track user.id) {
															<label class="list-group-item list-group-item-action py-1 px-2 d-flex align-items-center"
																[title]="user.email || ''">
																<input type="checkbox" class="form-check-input me-2"
																	[checked]="user.selected"
																	(change)="toggleMember(role, user)">
																<small>{{ user.firstName }} {{ user.lastName }}</small>
															</label>
														}
													</div>
												}
											</div>
										}
									}
								</div>
							}
						</ng-template>
					</div>
				</div>
			</div>
		}
		<!-- Berechtigungen: Für Manager/Owner editierbar, für andere nur lesbar -->
		@if (isManager || isOwner || isEditMode) {
			<div ngbAccordionItem [collapsed]="false">
				<h2 ngbAccordionHeader>
					<button ngbAccordionButton>Berechtigungen</button>
				</h2>
				<div ngbAccordionCollapse>
					<div class="accordion-body">
						@if (!isManager && isOwner) {
							<div class="alert alert-info small mb-2">
								<i class="bi bi-info-circle me-1"></i>
								Berechtigungen basieren auf Ihren Rechten. Sie können diese nur einschränken, nicht erweitern.
							</div>
						}
						<table class="table table-sm table-borderless mb-0 permissions-table" style="table-layout: fixed;">
							<colgroup>
								<col style="width: 60px;">
								<col>
								<col>
								<col>
								<col>
								<col>
							</colgroup>
							<thead>
								<tr class="small text-muted">
									<th></th>
									<th class="text-center">Anlegen</th>
									<th class="text-center">Löschen</th>
									<th class="text-center">Importieren</th>
									<th class="text-center">Ändern</th>
									<th class="text-center">Zuordnen</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td class="small fw-bold">Punkte</td>
									<td><div class="d-flex justify-content-center">
										<button type="button" class="btn btn-sm"
											[class.btn-success]="project.permissions?.anlegen"
											[class.btn-outline-secondary]="!project.permissions?.anlegen"
											(click)="togglePermission('anlegen')"
											[disabled]="!canEditPermissions || (!isManager && !canOwnerAdd)">
											{{project.permissions?.anlegen ? '✓' : '✗'}}
										</button>
									</div></td>
									<td><div class="d-flex justify-content-center">
										<button type="button" class="btn btn-sm"
											[class.btn-success]="project.permissions?.loeschen"
											[class.btn-outline-secondary]="!project.permissions?.loeschen"
											(click)="togglePermission('loeschen')"
											[disabled]="!canEditPermissions">
											{{project.permissions?.loeschen ? '✓' : '✗'}}
										</button>
									</div></td>
									<td><div class="d-flex justify-content-center">
										<button type="button" class="btn btn-sm"
											[class.btn-success]="project.permissions?.importieren"
											[class.btn-outline-secondary]="!project.permissions?.importieren"
											(click)="togglePermission('importieren')"
											[disabled]="!canEditPermissions || !isManager">
											{{project.permissions?.importieren ? '✓' : '✗'}}
										</button>
									</div></td>
									<td><div class="d-flex justify-content-center">
										<button type="button" class="btn btn-sm"
											[class.btn-success]="project.permissions?.aendern"
											[class.btn-outline-secondary]="!project.permissions?.aendern"
											(click)="togglePermission('aendern')"
											[disabled]="!canEditPermissions || (!isManager && !canOwnerWrite)">
											{{project.permissions?.aendern ? '✓' : '✗'}}
										</button>
									</div></td>
									<td><div class="d-flex justify-content-center">
										<button type="button" class="btn btn-sm"
											[class.btn-success]="project.permissions?.zuordnen"
											[class.btn-outline-secondary]="!project.permissions?.zuordnen"
											(click)="togglePermission('zuordnen')"
											[disabled]="!canEditPermissions">
											{{project.permissions?.zuordnen ? '✓' : '✗'}}
										</button>
									</div></td>
								</tr>
								<tr>
									<td class="small fw-bold">Bereiche</td>
									<td><div class="d-flex justify-content-center">
										<button type="button" class="btn btn-sm"
											[class.btn-success]="project.permissions?.bereicheAnlegen"
											[class.btn-outline-secondary]="!project.permissions?.bereicheAnlegen"
											(click)="togglePermission('bereicheAnlegen')"
											[disabled]="!canEditPermissions">
											{{project.permissions?.bereicheAnlegen ? '✓' : '✗'}}
										</button>
									</div></td>
									<td><div class="d-flex justify-content-center">
										<button type="button" class="btn btn-sm"
											[class.btn-success]="project.permissions?.bereicheLoeschen"
											[class.btn-outline-secondary]="!project.permissions?.bereicheLoeschen"
											(click)="togglePermission('bereicheLoeschen')"
											[disabled]="!canEditPermissions">
											{{project.permissions?.bereicheLoeschen ? '✓' : '✗'}}
										</button>
									</div></td>
									<td><div class="d-flex justify-content-center">—</div></td>
									<td><div class="d-flex justify-content-center">—</div></td>
									<td><div class="d-flex justify-content-center">—</div></td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		}
		@if (!isManager && isEditMode) {
			<!-- Read-only Teilnehmer-Anzeige für Nicht-Manager -->
			<div ngbAccordionItem [collapsed]="false" [disabled]="true">
				<h2 ngbAccordionHeader>
					<button ngbAccordionButton>Teilnehmer</button>
				</h2>
				<div ngbAccordionCollapse>
					<div ngbAccordionBody>
						<ng-template>
							<div class="mb-2">
								<small class="fw-bold">Eigentümer:</small>
								<small class="text-muted ms-1">{{ project.owner?.firstName }} {{ project.owner?.lastName }}</small>
								<small class="text-muted">({{ project.owner?.username }})</small>
							</div>
							@for (role of rolesConfig.memberRoles; track role.field) {
								<div class="mb-2">
									<small class="fw-bold d-block mb-1">{{ role.labelPlural }}:</small>
									@if (project[role.field]?.length) {
										@for (k of project[role.field]; track k.id) {
											<span class="badge bg-secondary me-1">{{ k.firstName }} {{ k.lastName }}</span>
										}
									} @else {
										<small class="text-muted">Keine</small>
									}
								</div>
							}
						</ng-template>
					</div>
				</div>
			</div>
		}
		<div ngbAccordionItem [collapsed]="true">
			<h2 ngbAccordionHeader>
				<button ngbAccordionButton>Dateianhänge</button>
			</h2>
			<div ngbAccordionCollapse>
				<div ngbAccordionBody>
					<ng-template>
						@if (isEditMode && editProjectId) {
							<bp-project-attachments
								[projectId]="editProjectId"
								[readonly]="false">
							</bp-project-attachments>
						} @else {
							<div class="text-muted small">
								Anhänge können nach dem Erstellen des Projekts hinzugefügt werden.
							</div>
						}
					</ng-template>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="modal-footer">
	<button ngbAutofocus type="button" class="btn btn-primary" (click)="onSave()" [disabled]="isNameTakenOrNoProject">Speichern</button>
</div>
